module.exports = __webpack_public_path__ + "img/编组 21@2x.60101dc0.png";